// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"a14d05c0","203":"96fef82e","453":"e09926b7","530":"0f0ee354","584":"be8d5987","638":"28178271","744":"8c1502bb","779":"21ac5364","920":"c38ae5ad"}[chunkId] + ".chunk.js";
};